module.exports = __webpack_public_path__ + "img/edit-alt.648c5a8f.svg";